import { Header } from "../components/head";
import { Footer } from "../components/footer";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

export default function News() {
  const newsItems = [
    {
      id: 1,
      title: "Application Window Now Open",
      date: "2025-9-07",
      category: "Application",
      content: "We are pleased to announce that the application window for the 2025-2026 academic year is now open. Students can apply through our AAS system or AGFA platform.",
      isNew: true
    },
    {
      id: 2,
      title: "Scholarship Opportunities Available",
      date: "2025-09-07",
      category: "Scholarship",
      content: "Multiple scholarship opportunities are now available for qualified students. Apply early to secure your funding for the upcoming academic year.",
      isNew: true
    },
    {
      id: 1,
      title: "Notice for Certificate, Diploma, and PhD applicants",
      date: "2025-9-07",
      category: "Notice",
      content: "For Certificate, Diploma, and PhD applicants, apply through AGFA, contact us on WhatsApp (+8619572907062), or email (arthurinternational0@gmail.com) us for guidance.",
      isNew: true
    },
    {
      id: 1,
      title: "SPECIAL NOTE",
      date: "2025-9-07",
      category: "Application",
      content: "If you apply through AGFA or AAS (selecting Other Universities or Other Courses), our admissions team will contact you after submission with a curated list of universities and courses to choose from.",
      isNew: true
    },
    {
      id: 3,
      title: "New University Partnerships",
      date: "2025-01-05",
      category: "Partnership",
      content: "We have established new partnerships with several prestigious universities, expanding our program offerings and increasing admission opportunities.",
      isNew: false
    },
    {
      id: 4,
      title: "AAS System Updates",
      date: "2025-05-20",
      category: "System",
      content: "The AAS application system has been updated with improved user interface and faster processing times. All users will benefit from these enhancements.",
      isNew: false
    },
    {
      id: 5,
      title: "Application Requirements Updated",
      date: "2025-02-15",
      category: "Requirements",
      content: "Please review the updated application requirements for the 2025-2026 academic year. Some documents and procedures have been modified.",
      isNew: false
    },
    {
      id: 6,
      title: "Holiday Office Hours",
      date: "2023-12-10",
      category: "Office",
      content: "Our office will have modified hours during the holiday season. Please check our contact page for updated availability.",
      isNew: false
    }
  ];

  const styles = {
    page: {
      background: 'linear-gradient(180deg, #0b0e14 0%, #0f1420 100%)',
      minHeight: '100vh',
      color: '#e6eef7'
    },
    container: {
      maxWidth: 1100,
      margin: '0 auto',
      padding: '24px 16px'
    },
    header: {
      textAlign: 'center',
      marginBottom: 32
    },
    title: {
      fontSize: 36,
      fontWeight: 800,
      margin: '0 0 8px',
      background: 'linear-gradient(135deg, #4a90e2 0%, #67b8ff 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    },
    subtitle: {
      fontSize: 16,
      opacity: 0.8,
      margin: 0
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: 20
    },
    card: {
      background: 'rgba(255,255,255,0.04)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 16,
      padding: 20,
      boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden'
    },
    newBadge: {
      position: 'absolute',
      top: 12,
      right: 12,
      background: 'linear-gradient(135deg, #ff4757 0%, #ff3742 100%)',
      color: '#fff',
      fontSize: 10,
      fontWeight: 800,
      padding: '4px 8px',
      borderRadius: 12,
      textTransform: 'uppercase',
      letterSpacing: 0.5
    },
    category: {
      display: 'inline-block',
      background: 'rgba(74, 144, 226, 0.2)',
      color: '#67b8ff',
      fontSize: 11,
      fontWeight: 700,
      padding: '4px 10px',
      borderRadius: 12,
      marginBottom: 12,
      textTransform: 'uppercase',
      letterSpacing: 0.5
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 700,
      margin: '0 0 8px',
      lineHeight: 1.3
    },
    date: {
      fontSize: 12,
      opacity: 0.7,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
      gap: 6
    },
    content: {
      fontSize: 14,
      lineHeight: 1.5,
      opacity: 0.9,
      margin: 0,
      fontFamily: "sans-serif"
    },
    readMore: {
      color: '#67b8ff',
      textDecoration: 'none',
      fontSize: 13,
      fontWeight: 600,
      marginTop: 12,
      display: 'inline-block'
    }
  };

  return (
    <>
      <Helmet>
        <title>NEWS | AIA</title>
        <meta name="description" content="Discover the latest news, scholarships, and study opportunities in China and India with AIA. Start your journey abroad today." />
      </Helmet>
      <Header newsPg={true} />
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={styles.header}>
            <h1 style={styles.title}>Latest News & Announcements</h1>
            <p style={styles.subtitle}>Stay updated with the latest information about applications, scholarships, and university partnerships</p>
          </div>

          <div style={styles.grid}>
            {newsItems.map((item, index) => (
              <motion.div
                key={item.id}
                style={styles.card}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{
                  transform: 'translateY(-4px)',
                  boxShadow: '0 15px 40px rgba(0,0,0,0.35)',
                  border: '1px solid rgba(74, 144, 226, 0.3)'
                }}
              >
                {item.isNew && <span style={styles.newBadge}>New</span>}

                <div style={styles.category}>{item.category}</div>

                <h3 style={styles.cardTitle}>{item.title}</h3>

                <div style={styles.date}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" />
                  </svg>
                  {new Date(item.date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>

                <p style={styles.content}>{item.content}</p>

                {/* <a href="#" style={styles.readMore}>Read more →</a> */}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
